export function memoize(func: Function) {
  const cache: Record<string, string> = {};

  return (...args: any) => {
    const key = JSON.stringify(args);
    if (!cache[key]) {
      cache[key] = func(...args);
    }
    return cache[key];
  };
}
